import {createClient} from '@sanity/client'

export const client = createClient({
    projectId: 'lhkgj8kr',
    dataset: 'production',
    useCdn: true, // set to `false` to bypass the edge cache
    apiVersion: '2025-04-08', // use current date (YYYY-MM-DD) to target the latest API version. Note: this should always be hard coded. Setting API version based on a dynamic value (e.g. new Date()) may break your application at a random point in the future.
    // token: process.env.SANITY_SECRET_TOKEN // Needed for certain operations like updating content, accessing drafts or using draft perspectives
})

// uses GROQ to query content: https://www.sanity.io/docs/groq
export async function getPosts() {
    const query = `
    *[_type == "post"] | order(publishedAt desc){
      _id,
      title,
      slug,
      publishedAt,
      mainImage,
      author->{
        name,
        image,
        slug
      },
      categories[]->{
        title
      }
    }
  `
    return client.fetch(query)
}

export async function getRecentPosts(limit = 10) {
    return client.fetch(`*[_type == "post"] | order(_createdAt desc)[0...${limit}]`)
}


export async function getPostBySlug(slug) {
    const query = `
    *[_type == "post" && slug.current == $slug][0]{
      _id,
      title,
      slug,
      publishedAt,
      mainImage,
      body,
      author->{
        name,
        image,
        slug,
        bio
      },
      categories[]->{
        title,
        description
      }
    }
  `
    const params = { slug }
    return client.fetch(query, params)
}